import styled from "@emotion/styled";
import colors from "/styles/colors";
export const StyledMobileTemplatePageContent = styled.div`
  width: 100%;
  margin-bottom: 64px;
  padding: 0 16px;
  position: relative;

  .template-center-link-wrapper {
    margin-top: 16px;
    display: flex;
    align-items: center;

    .arrow-left {
      padding-right: 4px;

      path {
        fill: ${colors.asphalt};
      }
    }

    .template-center-link {
      text-decoration: none;
      color: ${colors.asphalt};
    }
  }

  .template-top-section-wrapper {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
  }

  .assets-carousel-wrapper {
    height: 100%;
    margin-top: 24px;

    .template-image-wrapper {
      height: 100%;
      padding: 4px 14px;
      background: ${colors.riverstone};
      border-radius: 1.5px;

      .template-image {
        width: 100%;
        height: auto;
      }
    }

    .template-page-carousel {
      .slick-slider {
        .slick-list {
          .slick-track {
            padding: 16px 0;
          }
        }
      }
    }
  }

  .template-field-wrapper {
    padding-bottom: 8px;
  }

  .template-description-wrapper {
    margin-top: 56px;

    .template-description {
      font-size: 0.875rem;
      line-height: 24px;
    }
  }

  .button-wrapper {
    position: fixed;
    height: 80px;
    background: ${colors.white};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    bottom: 0;
    left: 0;
    box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.08);
    padding: 0 32px;
  }

  .benefits-wrapper {
    margin-top: 64px;
  }

  .long-description-wrapper {
    .template-long-description-divider {
      margin: 48px auto;
      border: 0;
      border-top: 2px solid #a2bbc155;
      width: 100%;
    }
  }
`;
